import { useOutletContext } from "react-router-dom";
import { PolicyAssignScope } from "../utils";

export type PolicyAddDetailOutletContextType = {
  scope: PolicyAssignScope;
  policyId: string;
  variantPlatformFilter: string | null;
};

export function usePolicyAddDetailOutletContext() {
  return useOutletContext<PolicyAddDetailOutletContextType>();
}
